import { render, staticRenderFns } from "./EditSkus.vue?vue&type=template&id=212f6d93&scoped=true"
import script from "./EditSkus.vue?vue&type=script&lang=js"
export * from "./EditSkus.vue?vue&type=script&lang=js"
import style0 from "./EditSkus.vue?vue&type=style&index=0&id=212f6d93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212f6d93",
  null
  
)

export default component.exports